// Token types for lexical analysis
export const TokenType = {
    // Literals
    IDENTIFIER: "IDENTIFIER",
    STRING: "STRING",
    NUMBER: "NUMBER",
    BOOLEAN: "BOOLEAN",
    NULL: "NULL",

    // Operators
    EQUALS: "eq",
    NOT_EQUALS: "ne",
    GREATER_THAN: "gt",
    GREATER_THAN_OR_EQUALS: "ge",
    LESS_THAN: "lt",
    LESS_THAN_OR_EQUALS: "le",
    IN: "in",

    // Logical operators
    AND: "and",
    OR: "or",
    NOT: "not",

    // Functions
    CONTAINS: "contains",
    STARTSWITH: "startswith",
    ENDSWITH: "endswith",
    NOW: "now",
    SUB: "sub",
    ADD: "add",
    DURATION: "duration",
    // Lambda operators
    ANY: "any",
    ALL: "all",

    // Punctuation
    LEFT_PAREN: "(",
    RIGHT_PAREN: ")",
    COMMA: ",",
    COLON: ":",
    SLASH: "/",
    // End of input
    EOF: "EOF"
} as const;

export type TokenType = (typeof TokenType)[keyof typeof TokenType];

export interface Token {
    type: TokenType;
    value: string;
    position: number;
}

// EDM types
export type EdmGuid = string & { readonly isEdmGuid: unique symbol };
export type EdmDateTimeOffset = string & { readonly isEdmDateTimeOffset: unique symbol };
